// extracted by css-extract-rspack-plugin
export default {"item":"src-app-components-forms-OptionBox-OptionBox-module__item-jTZs69","active":"src-app-components-forms-OptionBox-OptionBox-module__active-_jLrQU","readonly":"src-app-components-forms-OptionBox-OptionBox-module__readonly-m04Zv8"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"item\":\"src-app-components-forms-OptionBox-OptionBox-module__item-jTZs69\",\"active\":\"src-app-components-forms-OptionBox-OptionBox-module__active-_jLrQU\",\"readonly\":\"src-app-components-forms-OptionBox-OptionBox-module__readonly-m04Zv8\"}";
        // 1789362522809
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  